import React, { ReactElement, useEffect } from 'react';
import styled from 'styled-components';
import { Button } from '@mesa-labs/mesa-ui';
import { useOktaAuth } from '@okta/okta-react';
import { Header, HeaderContainer, SignInContainer, SubHeader } from '../common/SignInLayout';
import { AuthEvents, trackEvent } from '../../analytics';

export const randomString = (length = 10): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  return Array.from(new Array(length), () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
};

const ButtonContainer = styled.div`
  & > div {
    width: 100%;
  }
`;

function SignInOktaPage(): ReactElement {
  const { oktaAuth } = useOktaAuth();

  const handleSignIn = async () => {
    const nonce = randomString(25);
    await oktaAuth.signInWithRedirect({ originalUri: `/authorize?nonce=${nonce}`, nonce });
  };

  useEffect(() => {
    trackEvent(AuthEvents.SignInOktaView);
  }, []);

  return (
    <SignInContainer>
      <HeaderContainer>
        <Header>Sign in with Okta</Header>
        <SubHeader>
          Mesa partners with JLL to provide authentication to this app. Please
          sign in by clicking on the button below, which will forward you to
          Okta and redirect you back once sign in is complete.
        </SubHeader>
      </HeaderContainer>

      <ButtonContainer>
        <Button color="primary" onClick={handleSignIn} text="Sign in" width="100%" />
      </ButtonContainer>
    </SignInContainer>
  );
}

export default SignInOktaPage;
